import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "./scss/main.scss";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import configureStoreProd from "./config/configureStore.prod";
import Login from "./pages/auth/login";
import Forgotpassword from "./pages/auth/forgotpassword";
import Resetpassword from "./pages/auth/resetpassword";
import ChangePassword from "./pages/auth/changepassword";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/auth/profile";
import EditProfile from "./pages/auth/profile/editprofile";
import NotFoundPage from "./pages/NotFoundPage";
import Register from "./pages/auth/register";
import Blogs from "./pages/Blogs";
import BlogDetails from "./pages/Blogs/BlogDetails";
import HomePage from "./pages/HomePage";
import CardDetails from "./pages/Cards/CardDetails";
import CustomizeCard from "./pages/Cards/CustomizeCard";
import CardListing from "./pages/Cards/CardListing";
import Checkout from "./pages/Checkout/Checkout"
import MyCards from "./pages/MyCards";
import MyTransactions from "./pages/MyTransactions";
import TransactionDetail from "./pages/MyTransactions/TransactionDetail";
import ContactUs from "./pages/ContactUs";
import Faqs from "./pages/Faqs";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/terms";
import ViewCard from "./pages/MyCards/ViewCard";
import SMSPolicy from "./pages/SMSPolicy";

const { persistor, store } = configureStoreProd(); 

function App() {
  const routes = [
    { url: "/", element: <HomePage /> }, // Home Page Route
    { url: "*", element: <NotFoundPage /> },
    { url: "/login", element: <Login /> }, // Auth Routes
    { url: "/register", element: <Register /> },
    { url: "/forgotpassword", element: <Forgotpassword /> },
    { url: "/resetpassword", element: <Resetpassword /> },
    { url: "/changepassword", element: <ChangePassword /> },
    { url: "/dashboard", element: <Dashboard /> }, // Dashboard & Profile Routes
    { url: "/profile", element: <Profile /> },
    { url: "/contactus", element: <ContactUs /> },
    { url: "/faq", element: <Faqs /> },
    { url: "/aboutus", element: <About /> },
    { url: "/privacy", element: <Privacy /> },
    { url: "/terms", element: <Terms /> },
    { url: "/sms-policy", element: <SMSPolicy /> },
    { url: "/profile/edit", element: <EditProfile /> },
    { url: "/blogs", element: <Blogs /> }, // Blogs Routes
    { url: "/blog/detail/:id", element: <BlogDetails /> },
    { url: "/card/detail/:id", element: <CardDetails /> }, // Cards Route
    { url: "/card/customize/:id", element: <CustomizeCard /> },
    { url: "/cardlisting", element: <CardListing /> },
    { url: "/checkout", element: <Checkout /> }, // Checkout Page Route
    { url: "/mycards", element: <MyCards /> }, // MyCards Listing Route
    { url: "/mycard/:id", element: <ViewCard /> },
    { url: "/mytransactions", element: <MyTransactions /> }, // MyTransaction Route
    { url: "/transaction/detail/:id", element: <TransactionDetail /> },
  ];

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Router>
            <Routes>
              {routes.map((itm, index) => {
                return <Route path={itm.url} element={itm.element} key={index} />;
              })}
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer autoClose={2000} position="top-right" />
    </>
  );
}

export default App;
